import { render, staticRenderFns } from "./BasicTextSectionModule.vue?vue&type=template&id=5d900ecb&"
import script from "./BasicTextSectionModule.vue?vue&type=script&lang=js&"
export * from "./BasicTextSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports